// extracted by mini-css-extract-plugin
module.exports = {"establishments":"Companies_establishments__DMapq","header":"Companies_header__3Gxfd","tableHeader":"Companies_tableHeader__3I64o"};